import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";
import { CompromisedTransactions } from "./CompromisedTransactions";



const StalledTransaction = () => {
    return <>
    <AsideMenu>
        <UserGroupMenu destination="/stalled-transaction" />
    </AsideMenu>
    <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/stalled-transaction/:userGroup" permission={Permissions.STALLED_TRANSACTIONS} component={CompromisedTransactions} />
            </Switch>
        </Suspense>
    </Section>
</>
};

export default StalledTransaction;
